import React from "react";

function TestPage() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>Welcome to the Test Page!</h1>
        <p>You have successfully logged in.</p>
      </div>
  );
}

export default TestPage;
